import React,{useMemo,useState} from 'react';
import {useGetAllTenantsInfo} from './Hooks/index'
import DyDataGrid from '../../components/GlobalComponents/DyDataGrid/DyDataGrid';
import {Grid, Box,Typography} from '@mui/material';
import ModalLyt from "../../components/Layouts/ModalLyt/ModalLyt";
import DYToastMessage from '../../../src/components/GlobalComponents/DyToastMessage/DYToastMessage';
import AddLicense from './AddLicense';
import DeailyReport from './DeailyReport';
import RecoverTenant from './RecoverTenant';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import LoadingSpinner from '../../components/Progress/LoadingSpinner';
const Tenants = () => {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // برای بررسی سایز صفحه
  const {data:tenantData,isLoading:tenantsDataLoading,isError:tenantsDataError}=useGetAllTenantsInfo();
  const [showToastMessage, setShowToastMessage] = useState<boolean>(false);
  const tenantsColumns: any = useMemo(()=>[
      {
        field: "rowid",
        headerName: "ردیف",
        width: 75,
        sortable: false,
        align:'center',
        headerAlign:'center',
        renderCell: (params:any) => params.api.getAllRowIds().indexOf(params.id)+1
      },
        { field: 'name',
         align:'left',
         headerName: 'نام',
         headerAlign:'center',
         sortable:false,
         wrap:'wrap',
          width: 170,
          flex:1
      },
      { field: 'inviteCode',
      align:'center',
      headerName: 'کد دعوت',
      headerAlign:'center',
      sortable:false,
      wrap:'wrap',
       width:90
      },
      { field: 'scale',
        align:'center',
        headerName: 'اندازه',
        headerAlign:'center',
        sortable:false,
        wrap:'wrap',
         width:90
        }
      // teamCount
      ,
      { field: 'teamCount',
      align:'center',
      headerName: 'تعداد تیم',
      headerAlign:'center',
      sortable:false,
      wrap:'wrap',
       width:90
      }
      ,
      { field: 'objectiveCount',
      align:'center',
      headerName: 'تعداد هدف',
      headerAlign:'center',
      sortable:false,
      wrap:'wrap',
       width:90
      }
      ,
      { field: 'meetingCount',
      align:'center',
      headerName: ' تعداد جلسه',
      headerAlign:'center',
      sortable:false,
      wrap:'wrap',
       width:90
      }
      // meetingCount
      ,
      { field: 'keyResultCount',
      align:'center',
      headerName: 'تعداد نتیجه',
      headerAlign:'center',
      sortable:false,
      wrap:'wrap',
       width:90
      }
      // objectiveCount
      ,
      // keyResultCount
      { field: 'creator',
      align:'center',
      headerName: 'ایجاد کننده',
      headerAlign:'center',
      sortable:false,
       width:120
      }
      ,
      { field: 'phoneNumber',
      align:'center',
      headerName: 'شماره همراه',
      headerAlign:'center',
      sortable:false,
       width:100
      }
      ,
      { field: 'role',
      align:'center',
      headerName: 'سمت',
      headerAlign:'center',
      sortable:false,
       width:80
      }
      ,
      { field: 'companyType',
      align:'center',
      headerName: ' نوع تننت',
      headerAlign:'center',
      sortable:false,
       width:80
      }
      ,
      { field: 'personCount',
      align:'center',
      headerName: 'تعداد کاربران',
      headerAlign:'center',
      sortable:false,
       width:60,
      }
      ,
      { field: 'licensePersonCount',
        align:'center',
        headerName: 'حداکثر تعداد نفرات',
        headerAlign:'center',
        sortable:false,
         width:40,
      }  ,
      { field: 'dayRemainContract',
        align:'center',
        headerName: 'تعداد روز باقی مانده قرارداد',
        headerAlign:'center',
        sortable:false,
         width:90,
        }
        ,
      { field: 'createDate',
      align:'center',
      headerName: 'تاریخ ایجاد',
      headerAlign:'center',
      sortable:false,
       width:110,
       flex:1
      }
      ,
      { field: 'lastLoginDate',
      align:'center',
      headerName: 'تاریخ آخرین لاگین',
      headerAlign:'center',
      sortable:false,
       width:110,
       flex:1
      }
      ,
      { field: 'addLastPersonDate',
      align:'center',
      headerName: 'آخرین کاربر اضافه شده ',
      headerAlign:'center',
      sortable:false,
       width:120,
      },     
  ],[]);
  const [showAddLicense, setShowAddLicense] = useState<boolean>(false);
  const [showDeailyReport, setShowDeailyReport] = useState<boolean>(false);
  const [showRecoverTenant, setShowRecoverTenant] = useState<boolean>(false);

    const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const renderContent=()=>{
    if (tenantsDataLoading) {
      return (<Box  width={'100%'} py={16}   >
        <LoadingSpinner   />
      </Box>)
    }
    else {
      return <>
       <DyDataGrid
     rowHeight={10}
     data={tenantsDataError || tenantsDataLoading ? []:tenantData }
     columns={tenantsColumns || []}
     hideFooter={false}
     selectionModel={[]}
     initialOnRowClick={()=>{}}
     setSelectionModel={()=>{}}
    //  rowSelection={true}
     /></>
    }
  }
  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
  const initialAddLicense = (): void => {
    setShowAddLicense((prev) => !prev);
  };
  const initialDailyReport = (): void => {
    setShowDeailyReport((prev) => !prev);
  };
  const initialRecoverTenant = (): void => {
    setShowRecoverTenant((prev) => !prev);
  };

// data,columns,hideFooter,selectionModel,initialOnRowClick
  return (
    <>
    <Grid  sx={{bgcolor:'#F9F9F9',width:'100% !important',padding:'0px !important'}}   >
     <Grid item xs={12}   >
     <Box  mx={1} display={'flex'} my={1} justifyContent={'start'} borderRadius={2} boxShadow={2} bgcolor={'white'} py={1} sx={{padding:'0px !important'}}  >
     <Typography  px={2} py={1} fontWeight={500} color={'#00387C'} fontSize={'18px'} >لیست شرکت ها</Typography>
     </Box>
     <div>
     <Box display={'flex'} justifyContent={'end'}>
        <button
          onClick={(e: React.MouseEvent<HTMLElement>) =>
            initialAddLicense()
          }
          className={`btn px-4  text-xs font-thin text-white bg-[#00387c]
              btn-sm rounded-md m-2`}
          >
          تمدید قرارداد
        </button>

        <button
          onClick={(e: React.MouseEvent<HTMLElement>) =>
            initialDailyReport()
          }
          className={`btn px-4  text-xs font-thin text-white bg-[#00387c]
              btn-sm rounded-md m-2`}
          >
          گزارش روزانه
        </button>

        <button
          onClick={(e: React.MouseEvent<HTMLElement>) =>
            initialRecoverTenant()
          }
          className={`btn px-4  text-xs font-thin text-white bg-[#00387c]
              btn-sm rounded-md m-2`}
          >
          بازگردانی شرکت
        </button>
     </Box>
        <ModalLyt
          showModal={showAddLicense}
          setShowModal={setShowAddLicense}
          width={isMobile ? '350px' : '600px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
          height={500}
          title={"تمدید قرارداد"}
        >
          <AddLicense
            // periodsData={perData}
            onSuccess={setShowAddLicense}
            setShowToastMessage={setShowToastMessage}
            //setAddObjectiveStatus = {setAddObjectiveStatus}
            // setObjectiveAsyncOpState={setObjectiveAsyncOpState}
            // afterSuccess={getObjectivesAgain}
            onClose={setShowAddLicense}
          />
        </ModalLyt>
     </div>
     <div>
     <Box display={'flex'} justifyContent={'end'}>
       
     </Box>
        <ModalLyt
          showModal={showDeailyReport}
          setShowModal={setShowDeailyReport}
          width={isMobile ? '350px' : '600px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
          height={500}
          title={"گزارش روزانه"}
        >
          <DeailyReport
            // periodsData={perData}
            onSuccess={setShowDeailyReport}
            setShowToastMessage={setShowToastMessage}
            //setAddObjectiveStatus = {setAddObjectiveStatus}
            // setObjectiveAsyncOpState={setObjectiveAsyncOpState}
            // afterSuccess={getObjectivesAgain}
            onClose={setShowDeailyReport}
          />
        </ModalLyt>
     </div>
     <div>
     <Box display={'flex'} justifyContent={'end'}>
       
     </Box>
        <ModalLyt
          showModal={showRecoverTenant}
          setShowModal={setShowRecoverTenant}
          width={isMobile ? '350px' : '600px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
          height={500}
          title={"بازگردانی شرکت"}
        >
          <RecoverTenant
            onSuccess={setShowRecoverTenant}
            setShowToastMessage={setShowToastMessage}
            onClose={setShowRecoverTenant}
          />
        </ModalLyt>
     </div>
     </Grid>
     <Grid item xs={12}   >
     <Box textAlign={'center'}  mx={1} borderRadius={2} boxShadow={2} bgcolor={'white'} my={1} py={tenantsDataLoading?8:3}   >
    {
      renderContent()
    }
     </Box>
     </Grid>
     {
        showToastMessage &&
        <DYToastMessage
          show={true}
          setShow={setShowToastMessage}
          message={'عملیات باموفقیت انجام شد'}
          isSuccess={true}
        />
      }
    </Grid>
    </>
  )
}

export default Tenants